function CustomerKpiPanel({
  sectionTitleStyle,
  impiantiCliente = [],
  interventiCliente = [],
  scadenzeCliente = [],
}) {
  const manutenzioniAperte = scadenzeCliente.filter(
    (item) =>
      item.next_due_date ||
      item.frequency_months ||
      item.title?.toLowerCase().includes("manutenzione")
  ).length;

  const verificheAperte = Math.max(
    scadenzeCliente.length - manutenzioniAperte,
    0
  );

  return (
    <div
      style={{
        border: "1px solid #dbe4f0",
        borderRadius: "12px",
        padding: "16px",
        backgroundColor: "#f8fbff",
      }}
    >
      <h2 style={{ ...sectionTitleStyle, fontSize: "20px" }}>
        Stato cliente
      </h2>

      <div style={{ marginTop: "14px", lineHeight: "1.9" }}>
        <div>
          <strong>Impianti:</strong> {impiantiCliente.length}
        </div>

        <div>
          <strong>Interventi:</strong> {interventiCliente.length}
        </div>

        <div>
          <strong>Scadenze aperte:</strong> {scadenzeCliente.length}
        </div>

        {scadenzeCliente.length > 0 && (
          <div
            style={{
              marginTop: "10px",
              padding: "10px 12px",
              borderRadius: "10px",
              background: "#fff7ed",
              border: "1px solid #fed7aa",
              color: "#92400e",
              lineHeight: "1.6",
              fontSize: "14px",
              fontWeight: 600,
            }}
          >
            {manutenzioniAperte > 0 && (
              <div>
                ⚠️ {manutenzioniAperte} manutenzion
                {manutenzioniAperte === 1 ? "e" : "i"} aper
                {manutenzioniAperte === 1 ? "ta" : "te"}
              </div>
            )}

            {verificheAperte > 0 && (
              <div>
                ⚠️ {verificheAperte} verific
                {verificheAperte === 1 ? "a tecnica aperta" : "he tecniche aperte"}
              </div>
            )}
          </div>
        )}

        <div style={{ marginTop: "8px" }}>
          <strong>Cliente attivo:</strong>{" "}
          {impiantiCliente.length > 0 ? "Sì" : "Da verificare"}
        </div>
      </div>
    </div>
  );
}

export default CustomerKpiPanel;